import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      d="M13 5.33333H9H8.66667H8H7.33333H7H3C2.44772 5.33333 2 5.78104 2 6.33333C2 6.88561 2.44772 7.33333 3 7.33333H7H7.33333H8H8.66667H9H13C13.5523 7.33333 14 6.88561 14 6.33333C14 5.78104 13.5523 5.33333 13 5.33333ZM13 9.33333H9H8.66667H8H7.33333H7H3C2.44772 9.33333 2 9.78104 2 10.3333C2 10.8856 2.44772 11.3333 3 11.3333H7H7.33333H8H8.66667H9H13C13.5523 11.3333 14 10.8856 14 10.3333C14 9.78104 13.5523 9.33333 13 9.33333Z"
      fill={fill}
    />
  </g>
);

export default Icon;
